<template>
  <v-row no-gutters>
    <v-col cols="12" md="4">
      <v-row no-gutters class="mt-4 pl-4 pr-4">
        <v-col cols="12" md="12">
          <v-menu
            v-model="receiveMenu"
            full-width
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="finance.receivedDate"
                label="Receive Date"
                readonly
                v-on="on"
                hide-details
                dense
                filled
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="receivePicker"
              @input="receiveMenu = false"
              color="primary"
              :max="new Date().toISOString().substr(0, 10)"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="12" class="mt-2">
          <v-autocomplete
            item-text="profileName"
            :items="riderList"
            v-model="finance.rider"
            label="Rider"
            return-object
            hide-details
            outlined
            filled
            dense
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="12" class="mt-2">
          <v-text-field
            label="Opening Balance "
            v-model.number="finance.openingBalance"
            type="number"
            outlined
            filled
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12">
          <v-text-field
            label="Fuel Fees"
            v-model.number="finance.fuelFee"
            type="number"
            outlined
            filled
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12">
          <v-text-field
            label="Received Amount"
            v-model.number="finance.receivedAmount"
            type="number"
            outlined
            filled
            dense
          ></v-text-field>
        </v-col>
         <v-col cols="12" md="4" >
          <v-text-field
            label="10000"
            v-model.number="finance.is10000"
            type="number"
            outlined
            filled
            dense
          ></v-text-field>
        </v-col>
         <v-col cols="12" md="4" class="pl-2">
          <v-text-field
            label="5000"
            v-model.number="finance.is5000"
            type="number"
            outlined
            filled
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="pl-2">
          <v-text-field
            label="1000"
            v-model.number="finance.is1000"
            type="number"
            outlined
            filled
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            label="500"
            v-model.number="finance.is500"
            type="number"
            outlined
            filled
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" class="pl-2">
          <v-text-field
            label="200"
            v-model.number="finance.is200"
            type="number"
            outlined
            filled
            dense
          ></v-text-field>
        </v-col>
         <v-col cols="12" md="3" class="pl-2">
          <v-text-field
            label="100"
            v-model.number="finance.is100"
            type="number"
            outlined
            filled
            dense
          ></v-text-field>
        </v-col>
         <v-col cols="12" md="3" class="pl-2">
          <v-text-field
            label="50"
            v-model.number="finance.is50"
            type="number"
            outlined
            filled
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="text-right">
          <v-btn color="green" dark @click="clickSaveOrUpdate()">{{ saveOrupdate }}</v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="8" class="mt-3">
      <v-row no-gutters>
        <v-col cols="12" md="12">
          <v-row no-gutters>
            <v-col cols="5" md="2" class="pl-9">
              <v-menu
                v-model="fromMenu"
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDate"
                    label="From Date"
                    readonly
                    v-on="on"
                    hide-details
                    dense
                    outlined
                    filled
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromPicker"
                  @input="fromMenu = false"
                  color="primary"
                  :max="new Date().toISOString().substr(0, 10)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="5" md="2" class="pl-2">
              <v-menu
                v-model="toMenu"
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDate"
                    label="To Date"
                    readonly
                    v-on="on"
                    hide-details
                    dense
                    outlined
                    filled
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="toPicker"
                  @input="toMenu = false"
                  color="primary"
                  :max="new Date().toISOString().substr(0, 10)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" class="pl-2">
              <v-autocomplete
                item-text="profileName"
                :items="riderAllList"
                v-model="riderAll"
                label="Rider"
                return-object
                hide-details
                outlined
                filled
                dense
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="1" class="pb-2 pl-2">
              <v-btn fab small depressed color="primary" @click="getSearch()">
                <v-icon>search</v-icon>
              </v-btn>
            </v-col>
            
          </v-row>
        </v-col>
        <v-col cols="12" md="12">
          <v-simple-table
            :fixed-header="true"
            dense
            class="elevation-1 mb-2"
            height="85vh"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center white--text primary">No.</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Receive Date</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Rider</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">
                    Opening Balance
                  </th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Fuel Fees</th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">
                    Received Amount
                  </th>
                  <th class="text-center white--text primary">
                    <v-divider vertical></v-divider>
                  </th>
                  <th class="text-center white--text primary">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in financeDetail.financeList"
                  :key="index"
                  @click="selectedOne = item"
                  :style="{
                    backgroundColor:
                      item.financeId == selectedOne.financeId
                        ? '#def3ff'
                        : 'transparent',
                  }"
                >
                  <td class="text-center" ><span v-if="item.financeId !=0">{{ index + 1 }}</span></td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-center" ><span v-if="item.financeId !=0">{{ item.receivedDate }} </span>
                    <span v-else>Total</span>
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-left">{{ item.rider.profileName }}</td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-right">
                    {{ item.openingBalance | defaultPaymentFormat }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-right">
                    {{ item.fuelFee | defaultPaymentFormat }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-right">
                    {{ item.receivedAmount | defaultPaymentFormat }}
                  </td>
                  <td class="text-center"><v-divider vertical></v-divider></td>

                  <td class="text-center" >
                    <span v-if="item.financeId !=0">
                    <v-btn small icon color="green" @click="clickEdit(item)" >
                      <v-icon>edit</v-icon></v-btn
                    >
                    <v-btn small icon color="red" @click="clickDelete(item)" >
                      <v-icon>delete</v-icon></v-btn
                    >
                  </span>
                  </td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-col>
    <v-col>
      <v-dialog
      v-model="dialogDelete"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 red white--text">
          Do you want to delete({{deleteFinance.rider.profileName}})?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialogDelete = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red"
            @click="clickOkDelete()"
            dark
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import financeService from "../service/FinanceService";
import accountUserService from "../service/AccountUserService";
export default {
  data: () => ({
    selectedOne: {},
    financeDetail: {},
    fromPicker: new Date().toISOString().substr(0, 10),
    toPicker: new Date().toISOString().substr(0, 10),
    fromMenu: false,
    toMenu: false,
    fromDate: "",
    toDate: "",
    receivePicker: new Date().toISOString().substr(0, 10),
    receiveMenu: false,
    receivedDate: "",
    riderList: [],
    finance: { openingBalance: 0,fuelFee:0,receivedAmount:0,is10000:0,is5000:0,is1000:0,is500:0,is200:0,is100:0,is50:0 },
    riderAllList: [],
    riderAll: {},
    saveOrupdate:"SAVE",
    deleteFinance:{rider:{}},
    dialogDelete:false,
    
    
  }),
  props: {},
  mounted: function () {
    this.fromDate = this.formatDate(this.fromPicker);
    this.toDate = this.formatDate(this.toPicker);
    this.finance.receivedDate = this.formatDate(this.receivePicker);
    this.getUserList();
    this.getSearch();
  },
  methods: {
    clickOkDelete:function(){
      this.dialogDelete = false;
      financeService
        .deleteFinance(this.deleteFinance)
        .then((data) => {
          this.getSearch();
          this.$swal({
              title: "Successful",
              text: "Successful!",
              type: "success",
              timer: 500,
            });
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
    },
    clickDelete:function(item){
        this.deleteFinance = Object.assign({},item);
        this.dialogDelete = true;
    },
    clickEdit:function(item){
      this.finance = Object.assign({},item);
      this.saveOrupdate = "UPDATE";
    },
    clickSaveOrUpdate:function(){
      if(this.saveOrupdate == "SAVE"){
      financeService
        .addFinance(this.finance)
        .then((data) => {
          this.getSearch();
          this.$swal({
              title: "Successful",
              text: "Successful!",
              type: "success",
              timer: 500,
            });
            
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
      }else{
        financeService
        .updateFinance(this.finance)
        .then((data) => {
          this.getSearch();
          this.$swal({
              title: "Successful",
              text: "Successful!",
              type: "success",
              timer: 500,
            });
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
      }
    },
    getUserList: function () {
      accountUserService.getAccountDeliverys().then((response) => {
        this.riderList.splice(0, this.riderList.length);
        this.riderAllList.splice(0, this.riderAllList.length);
        this.riderAllList.push(
          { userAccountId: 0, profileName: "ALL" },
          ...response
        );
        this.riderList.push(...response);
        this.riderAll = this.riderAllList[0];
        this.finance.rider = this.riderList[0];
      });
    },
    formatDate(fromPicker) {
      const [year, month, day] = fromPicker.split("-");
      return `${day}-${month}-${year}`;
    },
    getSearch: function () {
      financeService
        .getFinance(this.fromDate, this.toDate, this.riderAll.userAccountId)
        .then((data) => {
          
          this.financeDetail = data;
          this.saveOrupdate = "SAVE";
          this.finance.openingBalance = 0;
            this.finance.fuelFee = 0;
            this.finance.receivedAmount =0;
           this.finance.is10000=0;
           this.finance.is5000=0;
           this.finance.is1000=0;
           this.finance.is500=0;
           this.finance.is200=0;
           this.finance.is100=0;
           this.finance.is50=0;
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
    },
  },
  watch: {
    fromPicker() {
      this.fromDate = this.formatDate(this.fromPicker);
    },
    toPicker() {
      this.toDate = this.formatDate(this.toPicker);
    },
    receivePicker() {
      this.finance.receivedDate = this.formatDate(this.receivePicker);
    },
  },
  components: {},
};
</script>
<style scoped>
.v-data-table td,
.v-data-table th {
  padding: 0 2px !important;
}
</style>